var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass: "switch",
      class: { loading: _vm.loading, indeterminate: _vm.indeterminate },
    },
    [
      _c("input", {
        staticClass: "switch-input",
        attrs: { type: "checkbox" },
        domProps: { checked: _vm.value },
        on: { change: _vm.handleInput },
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "switch-label",
        style: `color: ${_vm.color}`,
        attrs: { "data-on": _vm.labelOn, "data-off": _vm.labelOff },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "switch-handle" }),
      _vm._v(" "),
      _vm.loading ? _c("loader") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }